import {BrowserCacheLocation, InteractionType, IPublicClientApplication, PublicClientApplication} from '@azure/msal-browser';
import {MsalGuardConfiguration, MsalInterceptorConfiguration} from '@azure/msal-angular';
import {Util} from '../../utils/utils';

const isIE = window.navigator.userAgent.indexOf('MSIE ') > -1 || window.navigator.userAgent.indexOf('Trident/') > -1;

export function MSALInstanceFactory(): IPublicClientApplication {

  return new PublicClientApplication({
    auth: {
      // 'Application (client) ID' of app registration in the Microsoft Entra admin center - this value is a GUID
      clientId: Util.azureAdCoinfigs.clientId,
      // Full directory URL, in the form of https://login.microsoftonline.com/<tenant>
      authority: 'https://login.microsoftonline.com/' + Util.azureAdCoinfigs.tenentId,
      // Must be the same redirectUri as what was provided in your app registration.
      redirectUri: Util.azureAdCoinfigs.callBackPath,
      postLogoutRedirectUri: Util.azureAdCoinfigs.callBackPath,

    },

    system: {
      allowNativeBroker: true,
      asyncPopups: true,
      allowRedirectInIframe: true,

    },
    cache: {
      cacheLocation: BrowserCacheLocation.LocalStorage,
      storeAuthStateInCookie: isIE,
      secureCookies: true,
    }

  });
}

// MSAL Interceptor is required to request access tokens in order to access the protected resource (Graph)
export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map<string, Array<string>>();
  protectedResourceMap.set('https://graph.microsoft.com/v1.0/me', ['user.read']);

  return {
    interactionType: InteractionType.Popup,
    protectedResourceMap
  };
}

// MSAL Guard is required to protect routes and require authentication before accessing protected routes
export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Popup,
    authRequest: {
      scopes: [
        'openid',
        'profile',
        'email',
        'https://graph.microsoft.com/User.Read',
      ]
    }
  };
}
